import React, { useEffect, useRef, useState } from 'react'
import { useTheme } from '../../../middleware/ThemeContext';
import DashboardHeader from './DashboardHeader';
import OutstandingBalance from './OutstandingBalance';
import MembershipDuesCollected from './MembershipDuesCollected';
import PendingRenewals from './PendingRenewals';
import HighestDues from './HighestDues';
import AlmostMembers from './AlmostMembers';
import FirstRenewals from './FirstRenewals';
import MembersNeedAttention from './MembersNeedAttention';
import NewMembersSignUp from './NewMembersSignUp';

const MembershipDashboard = () => {
    const {theme} = useTheme();

  return (
    <>
    <DashboardHeader />
    <div className='container-fluid pt-3 mt-3 pb-4' style={{ background: theme.CorporateTheme?.colors?.filterBG, height: 'calc(-219px + 100vh)', overflowY: 'auto' }}>
        <div className='d-grid' style={{ gridTemplateColumns: '1fr 1fr 1fr', gap: '10px' }}>
            <OutstandingBalance />
            <MembershipDuesCollected />
            <PendingRenewals />
            <HighestDues />
            <AlmostMembers />
            <FirstRenewals />
        </div>
        <div className='row' style={{ marginTop: '10px' }}>
          <div className='col-7' style={{ padding: '0px 6px 0px 12px' }}>
            <MembersNeedAttention />
          </div>
          <div className='col-5' style={{ padding: '0px 12px 0px 6px' }}>
            <NewMembersSignUp />
          </div>
        </div>
    </div>
    </>
  )
}

export default MembershipDashboard